import Http from "./http";

export const loginAPI = (data) => {
  return Http.post("user/login",data);
};

export const logoutAPI = (data) => {
  return Http.post("/CampaignMember/logout",data);
};